import { IDataSource } from "../../../../../Data/DataSource";
import { Nullable } from "../../../../../Extensions";
import { Property } from "../../../../../RadObject";
import { IControl } from "../../../../../Ui/Controls/Control";
import { Evaluator } from "../../../SeriouslyRAD.Framework/Evaluation/Evaluator";
import { EvaluatorPropertyValues, IEvaluator } from "../../../SeriouslyRAD.Framework/Evaluation/IEvaluator";
import { NAMESPACE } from "./_Namespace";

export type GenericEvaluatorPropertyValues =
    EvaluatorPropertyValues
    & {
        evaluateFn: (context: Nullable<IControl | IDataSource>, state: any) => boolean;
    };

export type GenericEvaluatorProperties = {
    [name in keyof GenericEvaluatorPropertyValues]: Property<GenericEvaluatorPropertyValues[name]>
};

export interface IGenericEvaluator extends IEvaluator, GenericEvaluatorProperties
{
}

export class GenericEvaluator extends Evaluator<GenericEvaluatorPropertyValues> implements IGenericEvaluator
{
    public static override classNamespace = NAMESPACE + "GenericEvaluator";
    public static override className = "GenericEvaluator";

    // #region Properties

    public evaluateFn!: Property<(context: Nullable<IControl | IDataSource>, state: any) => boolean>;

    // #endregion

    // #region Overrides

    protected override __initializeProperties(propertyValues: GenericEvaluatorPropertyValues)
    {
        super.__initializeProperties(propertyValues);

        this.evaluateFn = new Property<(context: Nullable<IControl | IDataSource>, state: any) => boolean>(this, "System.Object, System.Private.CoreLib", propertyValues.evaluateFn);
    }

    public override clone()
    {
        const
            evaluator = super.clone();

        evaluator.evaluateFn.set(this.evaluateFn.get());

        return evaluator;
    }
    public override evaluate()
    {
        const
            evaluateFn = this.evaluateFn.get(),
            value = evaluateFn ? evaluateFn(this.context.get(), this.state.get()) : false;

        this.value.set(value);

        return value;
    }

    // #endregion
}

